import { showMessage } from "./messages";

export const MENSAGEM_ERRO_SISTEMA_PADRAO =
  "Não foi possível continuar. Tente novamente ou procure um atendente.";

type ErroTratado = {
  erroSistemaTratado?: boolean;
  horarioRestritoTratado?: boolean;
};

/**
 * Modal genérica para falha de sistema/configuração (env var obrigatória
 * ausente, handshake do token público indisponível etc.) — não é para erro
 * de negócio (esses seguem usando showMessage "warning" normalmente).
 * allowOutsideClick: false força o operador do totem a reconhecer o erro.
 */
export function showSystemErrorModal(mensagem?: string) {
  showMessage(
    "error",
    "Ops, algo deu errado",
    mensagem || MENSAGEM_ERRO_SISTEMA_PADRAO,
    { showConfirmButton: true, allowOutsideClick: false },
  );
}

// Mesma convenção do horarioRestritoTratado (services/api/index.ts): marca o
// erro para que quem chamou não mostre um segundo modal genérico em cima do
// mesmo problema.
export function marcarErroSistemaTratado<E>(error: E): E {
  (error as E & ErroTratado).erroSistemaTratado = true;
  return error;
}

export function erroJaTratado(error: unknown): boolean {
  const tratado = error as ErroTratado | null | undefined;
  return Boolean(tratado?.erroSistemaTratado || tratado?.horarioRestritoTratado);
}

// Mostra o modal genérico e lança um erro já marcado — para uso em pontos de
// configuração obrigatória ausente (ex.: Id-Sistema, chave do token público).
export function dispararErroSistema(mensagem: string): never {
  showSystemErrorModal(mensagem);
  throw marcarErroSistemaTratado(new Error(mensagem));
}
